import React, { useState } from "react";
import PopUpImage from "assets/images/quote_images/quote_popup_image.png";
import { useLocationGetInTouch } from "hooks/Forms/useLocationGetInTouch";
import { useForm } from "react-hook-form";
import ThankYouPopup from "components/popup/thankYouPopup";
import Loader from "components/loader";
import { useLocation } from "@reach/router";
import { Link } from "gatsby";

export default function Modal({ open, setOpen }) {
  const [thankOpen, setThankOpen] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { status, mutateAsync } = useLocationGetInTouch();
  const location = useLocation();

  const onSubmit = (data) => {
    const postData = {
      name: data.name,
      email: data.email,
      message: data.message,
      pagelink: location.href,
    };

    mutateAsync(postData).then((_) => {
      reset();
      setThankOpen(true);
      setOpen(false);
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {open && (
        <React.Fragment>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-scroll fixed inset-0 z-50 outline-none focus:outline-none font-primary">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="relative  flex items-center justify-between  w-11/12 sm:w-auto  bg-white flex-col lg:flex-row max-w-5xl top-10 sm:top-0 sm:mt-16 py-5 lg:py-0"
            >
              <img
                src={PopUpImage}
                alt="loading..."
                className="w-18 hidden lg:block"
              />
              <div className="px-4 relative right-0">
                <button
                  className="closetbn block ml-auto font-bold w-[24px] outline-none focus:outline-none  ease-linear transition-all duration-150 "
                  type="button"
                  onClick={handleClose}
                >
                  <img src="https://tomedes.gumlet.io/frontend/images/home-en/popup_assets/close_dark.svg" />
                </button>
                <h5 className="text-orange font-arial  font-bold text-3xl text-center pb-5">
                  Contact <span className="text-blue">Us</span>
                </h5>
                <p
                  className="font-opensans text-sm text-center px-4 lg:px-10 pb-6 "
                  style={{ color: "#000C27" }}
                >
                  Enter your details and we will get back to you within a few
                  minutes
                </p>
                <div className="flex justify-between items-center  flex-wrap lg:flex-nowrap lg:flex-row flex-col lg:gap-3">
                  <label className="flex flex-col w-full">
                    <span
                      className="modal-label font-opensans text-[11px] "
                      style={{ color: "#000C27" }}
                    >
                      Name<i className="text-red">*</i>
                    </span>
                    <input
                      type="text"
                      name="name"
                      className="modal-input font-opensans text-[11px] text-pop-up-200 min-w-[230px] px-2 py-1 w-full border border-pop-up-100 h-[32px] outline-none"
                      placeholder="Your name"
                      {...register("name", { required: true })}
                    />
                    {errors.name && (
                      <span className="text-red text-xs">
                        This field is required
                      </span>
                    )}
                  </label>
                  <label className="flex flex-col w-full">
                    <span
                      className="modal-label font-opensans text-[11px] "
                      style={{ color: "#000C27" }}
                    >
                      Email Address<i className="text-red">*</i>
                    </span>
                    <input
                      type="text"
                      name="email"
                      className="modal-input font-opensans text-[11px] text-pop-up-200 min-w-[230px] px-2 py-1 w-full border border-pop-up-100 h-[32px] outline-none"
                      placeholder="Your email address"
                      {...register("email", { required: true })}
                    />
                    {errors.email && (
                      <span className="text-red text-xs">
                        This field is required
                      </span>
                    )}
                  </label>
                </div>
                <label>
                  <span
                    className="modal-label font-opensans text-[11px] mt-1"
                    style={{ color: "#000C27" }}
                  >
                    Tell us more about your needs
                  </span>
                  <textarea
                    id=""
                    name="message"
                    rows="2"
                    style="resize:none;"
                    className="modal-input px-2 py-2 font-opensans text-[11px] text-pop-up-200 border border-pop-up-100 w-full "
                    placeholder="One member of our team will contact you within a few minutes"
                    {...register("message")}
                  />
                  {errors.message && (
                    <span className="text-red text-xs">
                      This field is required
                    </span>
                  )}
                </label>
                <div className="mb-9 relative">
                  <div className="flex items-baseline gap-2 absolute top-[-10px]">
                    <p className="text-sm text-darkBlue font-opensans">
                      *I agree to Tomedes'&nbsp;
                      <Link
                        to="/privacy"
                        className="text-orange hover:text-newOrange-100 underline transition-colors"
                      >
                        Privacy Policy
                      </Link>
                      &nbsp;by submitting this form.
                    </p>
                  </div>
                </div>
                <button
                  className="btn orn-btn w-full lg:w-32 h-10 text-white bg-orange font-opensans font-bold block mx-auto mt-2"
                  id="emailsubmit"
                >
                  {status === "loading" ? <Loader /> : "SUBMIT"}
                </button>
              </div>
            </form>
          </div>
          <div className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"></div>
        </React.Fragment>
      )}
      <ThankYouPopup
        open={thankOpen}
        setOpen={setThankOpen}
        setOpenPopUp={setOpen}
      />
    </>
  );
}
